import {Component} from '@angular/core';
import {ApplicationStateService} from '../../../../services/application.state.service';
import {FilterService} from '../../../../services/filter/filter.service';
import {AbstractDoorPanelComponent, LoadedProduct} from '../../../../panels/abstract.door-panel.component';
import {TrackingService} from '../../../../services/tracking.service';
import {DoorService} from '../../../../services/door/door.service';
import {CustomerService} from '../../../../services/customer/customer.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DoorTypeValidationService} from "../../../../services/doorTypeValidation/door-type-validation.service";
import {DoorType} from "../../../../models/door";

@Component({
  selector: 'app-door-panel',
  templateUrl: './door-panel.component.html'
})
export class DoorPanelComponent extends AbstractDoorPanelComponent {

  constructor(
    doorService: DoorService,
    applicationStateService: ApplicationStateService,
    customerService: CustomerService,
    filterService: FilterService<any>,
    trackingService: TrackingService,
    router: Router,
    route: ActivatedRoute,
    translationService: TranslateService,
    doorTypeValidationService: DoorTypeValidationService,
  ) {
    super(doorService, applicationStateService, customerService, filterService, trackingService, router, doorTypeValidationService, route, translationService);
  }

  active = 1;

  // For those door types 4 doors are shown in one row
  public narrowDoorTypes: Array<DoorType> = [
    DoorType.SINGLE,
    DoorType.INTERIOR,
  ];

  override onProductSelected(product: LoadedProduct) {
    super.onProductSelected(product);
  }
}
